import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const updateMedicalCertificate = createAsyncThunk(
    "medicalCertificate/updateMedicalCertificate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/medicalCertificate/updateMedicalCertificate", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getAllMedicalCertificate = createAsyncThunk(
    "medicalCertificate/getAllMedicalCertificate",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/medicalCertificate/getAllMedicalCertificate", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    medicalCertificate: [],
    medicalCertificateId: [],
    updateMedicalCertificateSuccessMessage: null,
    updateMedicalCertificateErrorMessage: null,
}
const healthScreeningPackageSlice = createSlice({
    name: "medicalCertificate",
    initialState,
    reducers: {
        resetCreateHealthScreeningMessage: (state) => {
            state.updateMedicalCertificateSuccessMessage = null;
            state.updateMedicalCertificateErrorMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateMedicalCertificate.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateMedicalCertificate.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateMedicalCertificateErrorMessage = action.payload.result.message;
                } else {
                    state.updateMedicalCertificateSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateMedicalCertificate.rejected, (state, action) => {
                state.loading = false;
                state.updateMedicalCertificateErrorMessage = action.payload.result.message;
            })
            .addCase(getAllMedicalCertificate.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllMedicalCertificate.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchMessage = action.payload.result.message;
                    state.medicalCertificate = [];
                } else {
                    state.searchMessage = null;
                    state.medicalCertificate = action.payload.result.list;
                }
            })
            .addCase(getAllMedicalCertificate.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const { resetCreateHealthScreeningMessage } = healthScreeningPackageSlice.actions;

export default healthScreeningPackageSlice.reducer;